<containerless></containerless>

<div class="${hidden ? 'tooltip hidden' : 'tooltip'}">
  <div class="tooltip-content">
    <h4>${title ? title : 'question help'}</h4>
    <au-slot></au-slot>
  </div>
</div>
